import { Navigate, Route } from "react-router";

import { Goto } from "@/shared/navigation";

import {
  CreateIngestionRule,
  EditIngestionRule,
  IngestionRuleDetail,
} from "./IngestionRules";

const RULES = Goto.route.Settings.Ingestion.Rules;

/**
 * Routes for each ingestion rule's own pages. The rules list is the Settings →
 * Ingestion tab, so the pages' parent URL redirects there. React Router ranks
 * the static `new` segment above `:ruleId`, so it is never read as a rule id.
 */
export const IngestionRulesRoutes = () => [
  <Route
    key="ingestionRules"
    path={RULES}
    element={<Navigate to={Goto.route.Settings.Ingestion.Root} replace />}
  />,
  <Route
    key="ingestionRuleCreate"
    path={`${RULES}/new`}
    element={<CreateIngestionRule />}
  />,
  <Route
    key="ingestionRuleEdit"
    path={`${RULES}/:ruleId/edit`}
    element={<EditIngestionRule />}
  />,
  <Route
    key="ingestionRuleDetail"
    path={`${RULES}/:ruleId`}
    element={<IngestionRuleDetail />}
  />,
];
